import { TStore } from "models";

export const selectSubscription = (state: TStore) => state?.payments?.data?.subscription